module.exports = __webpack_public_path__ + "img/29.46d4a0c9.png";